import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import PeakTimeBoard from './PeakTimeBoard';
import useDashboardMetric from '../../hooks/useDashboardMetric';
import dashboardService from '../../services/dashboardService';
import { buildTeamMemberIdsParam, buildTeamMemberKey } from '../../utils/dashboardMetricUtils';

const PeakTimeCard = ({ storeId, teamMemberIds }) => {
  const { t } = useTranslation();
  const [attempt, setAttempt] = useState(0);
  const metric = useDashboardMetric({
    cacheKey: `dashboard:peak:${storeId}:${buildTeamMemberKey(teamMemberIds)}`,
    fetcher: () => dashboardService.getDashboardPeakTimes(storeId, {
      teamMemberIds: buildTeamMemberIdsParam(teamMemberIds),
    }),
    enabled: Boolean(storeId),
    revision: attempt,
  });

  if (metric.forbidden) return null;

  return (
    <DashboardCard
      id="dashboard-peak-times"
      title={t('dashboard.peak.title')}
      subtitle={t('dashboard.peak.subtitle')}
      isLoading={metric.loading && !metric.data}
      hasError={Boolean(metric.error)}
      onRetry={() => setAttempt((current) => current + 1)}
    >
      <Box>
        {metric.data && <PeakTimeBoard hours={metric.data.hours} cells={metric.data.cells} />}
      </Box>
    </DashboardCard>
  );
};

export default PeakTimeCard;
